import { render, staticRenderFns } from "./CallAction.vue?vue&type=template&id=af889688&scoped=true"
import script from "./CallAction.vue?vue&type=script&lang=js"
export * from "./CallAction.vue?vue&type=script&lang=js"
import style0 from "./CallAction.vue?vue&type=style&index=0&id=af889688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af889688",
  null
  
)

export default component.exports